/**
 * NOTE: THIS API IS ONLY HERE TEMPORARY to mimic the APIs in the upcoming MobX rewrite. When the rewrite
 * is done, we should remove this types file and rely on API of the new FormRenderer component.
 *
 * A map of callbacks which can be used to hook into the lifecycle of the Portal Create.
 *
 * Each callback will be passed a LifecycleEvent object which will contain context from which
 * the event was triggered.
 */

export var PortalCreateLifecycleStage = /*#__PURE__*/function (PortalCreateLifecycleStage) {
  PortalCreateLifecycleStage["FormRenderComplete"] = "formRenderComplete";
  return PortalCreateLifecycleStage;
}({});